import { FormInput } from "./bento";
import { StyledSelectButton } from "./GeneralStyledComponents";
import { Image, type ImageProps } from "./Image";
import { XStack, YStack } from "./Stacks";
import { Paragraph } from "./Typography";
export type FeedbackFormOptionConfig = {
  label: string;
  image?: ImageProps["src"];
  emoji?: string;
};
type FeedbackFormProps = {
  options: FeedbackFormOptionConfig[];
  selectedOptions: string[];
  onSelectedOptionsChange: (selectedOptions: string[]) => void;
  moreDetailsPlaceholder?: string;
  /** When defined (including empty string), shows the more details text input instead of options */
  moreDetailsText?: string;
  onMoreDetailsTextChange?: (text: string) => void;
};
export function FeedbackForm({
  options,
  selectedOptions,
  onSelectedOptionsChange,
  moreDetailsPlaceholder,
  moreDetailsText,
  onMoreDetailsTextChange
}: FeedbackFormProps) {
  const toggleOption = (label: string) => {
    const newOptions = selectedOptions.includes(label) ? selectedOptions.filter(o => o !== label) : [...selectedOptions, label];
    onSelectedOptionsChange(newOptions);
  };

  // Show more details screen when moreDetailsText is defined (including empty string)
  if (moreDetailsText !== undefined) {
    return <FormInput value={moreDetailsText} onChangeText={onMoreDetailsTextChange} placeholder={moreDetailsPlaceholder} multiline numberOfLines={4} autoFocus />;
  }
  return <YStack gap="$6" data-sentry-element="YStack" data-sentry-component="FeedbackForm" data-sentry-source-file="FeedbackForm.tsx">
      <YStack gap="$3.5" alignItems="center" data-sentry-element="YStack" data-sentry-source-file="FeedbackForm.tsx">
        {options.map(option => {
        const {
          label,
          image,
          emoji
        } = option;
        return <StyledSelectButton key={label} flexGrow={0} flexShrink={0} alignSelf="center" selected={selectedOptions.includes(label)} onPress={() => toggleOption(label)}>
              {emoji ? <XStack gap="$2" alignItems="center">
                  <Paragraph>{emoji}</Paragraph>
                  <Paragraph color="$textDefault">{label}</Paragraph>
                </XStack> : image ? <XStack gap="$2" alignItems="center">
                  <Image src={image} width={24} height={24} borderRadius={4} />
                  <Paragraph color="$textDefault">{label}</Paragraph>
                </XStack> : label}
            </StyledSelectButton>;
      })}
      </YStack>
    </YStack>;
}